import React from 'react'
import "./Manual.css"
import { FileTextOutlined } from "@ant-design/icons"
import war from "../../../assets/war.png"

const Manual = () => {
  return (
    <div>
      <div className='card_manual'>
        <h4 className='exp_msn'>Manuals</h4>
        <div className='file'><FileTextOutlined /></div>
        <div className='btn_12c'>
          <button >
            User Manual
          </button>
        </div>
        <div className='btn_12c1'>
          <button>
            Service Manual
          </button>
        </div>
      </div>

      <div className='war_1'>
        <h4 className='war_2'>Warranty</h4>
        <div className='new_card2'>
          <img className='war' alt='' src={war} />
        </div>
      </div>


    </div>
  )
}

export default Manual
